import { Trans } from '@lingui/react/macro';
import { renderFileMarkdown } from '../../lib/markdown';

export function MarkdownViewer({
  content,
  onEdit,
}: {
  content: string;
  onEdit?: () => void;
}) {
  const html = renderFileMarkdown(content);

  return (
    <div className="markdown-viewer">
      {onEdit && (
        <div className="markdown-viewer-toolbar">
          <button className="btn-edit-md" onClick={onEdit}><Trans>Edit</Trans></button>
        </div>
      )}
      <div
        className="markdown-viewer-content"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </div>
  );
}
